/**
 * VendorPortalTermService
 * Service for vendor term management (CRUD operations on own terms).
 * Route: api/vendor-portal/terms
 */
import { VendorPortalBaseService } from './VendorPortalBaseService';
/**
 * VendorPortalTermService
 * Handles vendor term operations for the vendor portal.
 * Maps to /api/vendor-portal/terms endpoint
 */
export class VendorPortalTermService extends VendorPortalBaseService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? VendorPortalTermService.DEFAULT_SERVICE_PATH,
            basePath: config?.basePath ?? VendorPortalTermService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    // ==================== GET ALL ====================
    /**
     * Get all terms for the current vendor
     * GET /api/vendor-portal/terms
     */
    async getTerms() {
        const response = await this.getTermsRaw();
        return response.data ?? [];
    }
    /**
     * Get all terms (raw response)
     */
    getTermsRaw() {
        return this.get();
    }
    // ==================== GET BY COMPOSITE KEY ====================
    /**
     * Get a specific term by composite key (termPeriodTypeId, locationId)
     * GET /api/vendor-portal/terms/{termPeriodTypeId}/{locationId}
     */
    async getTerm(termPeriodTypeId, locationId) {
        const response = await this.getTermRaw(termPeriodTypeId, locationId);
        if (!response.data) {
            throw new Error(`Term with termPeriodTypeId ${termPeriodTypeId} and locationId ${locationId} not found`);
        }
        return response.data;
    }
    /**
     * Get a specific term (raw response)
     */
    getTermRaw(termPeriodTypeId, locationId) {
        return this.get(`${termPeriodTypeId}/${locationId}`);
    }
    // ==================== CREATE ====================
    /**
     * Create a new term for the current vendor
     * POST /api/vendor-portal/terms
     */
    async createTerm(data) {
        const response = await this.createTermRaw(data);
        if (!response.data) {
            throw new Error('Failed to create term');
        }
        return response.data;
    }
    /**
     * Create a new term (raw response)
     */
    createTermRaw(data) {
        return this.post('', data);
    }
    // ==================== UPDATE ====================
    /**
     * Update an existing term
     * PUT /api/vendor-portal/terms/{termPeriodTypeId}/{locationId}
     */
    async updateTerm(termPeriodTypeId, locationId, data) {
        const response = await this.updateTermRaw(termPeriodTypeId, locationId, data);
        if (!response.data) {
            throw new Error(`Failed to update term with termPeriodTypeId ${termPeriodTypeId} and locationId ${locationId}`);
        }
        return response.data;
    }
    /**
     * Update an existing term (raw response)
     */
    updateTermRaw(termPeriodTypeId, locationId, data) {
        return this.put(`${termPeriodTypeId}/${locationId}`, data);
    }
}
VendorPortalTermService.DEFAULT_SERVICE_PATH = 'vendors';
VendorPortalTermService.BASE_PATH = 'api/vendor-portal/terms';
//# sourceMappingURL=VendorPortalTermService.js.map